import React from "react";

export default function DeletePopup({title, isOpen, onClose, onConfirm, data }) {
  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50">
      <div className="w-[400px] p-8 bg-white rounded-lg shadow-lg text-center">
        <h3 className="mb-4 text-xl font-semibold text-gray-700">Delete?</h3>
        <p className="mb-6 text-gray-600">
          Are you sure you want to delete this {title}?
          <br />
          <strong>{data}</strong>
         
        </p>
        <div className="flex justify-center gap-4">
          <button
            className="px-6 py-2 text-gray-500 bg-gray-200 rounded-md hover:bg-gray-300"
            onClick={onClose}
          >
            No
          </button>
          <button
            className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
            onClick={onConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}
